// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".right-align[data-v-314241e6]{float:right}.gauges[data-v-314241e6]{display:flex;justify-content:space-around}.gauges>*[data-v-314241e6]{flex:1;margin-right:1.75%}.gauges__pods[data-v-314241e6]{flex-wrap:wrap;justify-content:left}.gauges__pods .count-gauge[data-v-314241e6]{width:23%;margin-bottom:10px;flex:initial}.caption[data-v-314241e6]{margin-bottom:.5em}", ""]);
// Exports
module.exports = exports;
